export const RESET_STATE = 'RESET_STATE';
export const SYNC_DATA = 'SYNC_DATA';
export const GET_THIRD_PARTY_PROVIDERS = 'GET_THIRD_PARTY_PROVIDERS';
export const UPDATE_LAST_CHECK_FOR_NOVELTIES = 'UPDATE_LAST_CHECK_FOR_NOVELTIES';